/**
 * @description Ad SDK enum. Used to pull Import module from Tag config
 * @type {{DAI_API: string, IMA_DAI: string, IMA: string, NONE: undefined}}
 */
export const AdSDK: { IMA: string; IMA_DAI: string; DAI_API: string; NONE: undefined; } = {

	/**
	 * @description IMA SDK
	 */
	IMA: 'ima',

	/**
	 * @description IMA DAI SDK
	 */
	IMA_DAI: 'ima_dai',

	/**
	 * @description DAI API
	 */
	DAI_API: 'dai_api',

	/**
	 * @description NONE (no SDK required)
	 */
	NONE: undefined

};